import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Avatar, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Tab from '../Tab';
import Layout from '../Layout';
import ErrorAlert from '../../components/ErrorAlert';
import { getClaimBusinessRequest, resetState } from '../../modules/places';
import Status from './components/Status';

class ClaimBusinessRequestTab extends Tab {
  state = {
    ...this.state,
    isFilter: {
      categories: false,
      types: false,
    },
  };

  actions = [
    { key: 'edit', icon: 'edit', title: 'Edit' },
  ];

  columns = this.renderColumns();

  renderColumns() {
    return [
      { key: 'id', title: 'ID', dataIndex: 'id' },
      {
        key: 'user',
        title: 'User',
        dataIndex: 'user',
        render: (user, data) => {
          return (
            <Fragment>
              <Avatar
                size="large"
                src={user.logo}
                className="mr-1"
              />
              <Link to={`/clients/${user.id}`}>{user.full_name}</Link>
            </Fragment>
          );
        },
      },
      {
        key: 'place',
        title: 'Place',
        dataIndex: 'place',
        render: (place) => {
          return (
            <Fragment>
              <Avatar
                size="large"
                src={place.logo}
                className="mr-1"
              />
              <Link to={`/places/${place.id}`}>{place.name}</Link>
            </Fragment>
          );
        },
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: (status) => <Status status={status} />,
      },
      this.tableActions(),
    ];
  }

  updateFilter = name => (value) => () => {
    let { filter, page, isFilter } = this.state;

    if (!filter[name]) {
      filter[name] = [];
    }

    if (!filter[name].includes(value)) {
      filter[name].push(value);
      page.number = 0;

      this.setState({
        filter,
        page,
        isFilter: { ...isFilter, [name]: true },
      }, () => {
        this.getData();
        this.addParamsToUrl();
      });
    }

  };

  clearFilter = name => (value) => (e) => {
    e.stopPropagation();

    const { filter, isFilter } = this.state;

    if (filter[name].includes(value)) {
      filter[name] = filter[name].filter(item => item !== value);

      this.setState({ ...this.state, filter }, () => {
        this.getData();
        this.addParamsToUrl();
      });

      if (filter[name].length === 0) {
        this.setState({
          ...this.state,
          isFilter: { ...isFilter, [name]: false },
        });
      }
    }

    if (!value) {
      this.setState({
        ...this.state,
        filter: { ...filter, [name]: [] },
        isFilter: { ...isFilter, [name]: false },
      }, () => {
        this.getData();
        this.addParamsToUrl();
      });
    }
  };

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error} />
        <Row>
          <Col>
            {this.renderFiltersBlock(this.renderSearchInput('search', 'search'))}
          </Col>
        </Row>
        <Row>
          <Col>
            {/*<CatFilterList catArray={this.props.categories.data.results}
                           selectedCatArray={this.state.filter.categories}
                           updateFilter={this.updateFilter('categories')}
                           clearFilter={this.clearFilter('categories')}
                           isFilter={this.state.isFilter.categories || this.props.location.search.includes(
                             'categories')}
            />
            <TypeFilterList typesArray={this.props.types.data.results}
                            selectedTypesArray={this.state.filter.types}
                            updateFilter={this.updateFilter('types')}
                            clearFilter={this.clearFilter('types')}
                            isFilter={this.state.isFilter.types || this.props.location.search.includes(
                              'types')}
            />*/}
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderDataTable()}
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.places,
    data: state.places.claimBusinessRequests || { results: [], total: 0 },
  }),
  {
    get: getClaimBusinessRequest, resetState,
  })(ClaimBusinessRequestTab);




// WEBPACK FOOTER //
// ./src/containers/ClaimBusiness/ClaimBusinessRequestTab.js